export default {
  props: {
    title: "",
    isShowHeader: {
      default: function _default() {
        return true;
      },
      type: Boolean
    },
    tableData: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    header: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  mounted: function mounted() {},
  methods: {
    getRowKey: function getRowKey(row) {
      /** 检查row.id是否有重复的缓存对象 */
      if (!this.checkRepeatObj) {
        this.checkRepeatObj = {};
      }

      if (row) {
        if (row.id) {
          if (this.checkRepeatObj[row.id]) {
            if (!row._secondId) {
              row._secondId = Math.random() + "";
            }
            /** 方便根据key重用元素 */


            return row._secondId;
          } else {
            this.checkRepeatObj[row.id] = 1;
            return row.id;
          }
        }

        if (!row._secondId) {
          row._secondId = Math.random() + "";
        }

        return row._secondId;
      } else {
        return Math.random() + "";
      }
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex == 1) {
        if (row.content) {
          if (row.content > row.upperLimit) {
            return {
              color: "#ef5350"
            };
          } else if (row.content < row.lowerLimit) {
            return {
              color: "#42a5f5"
            };
          }
        }
      }
    }
  }
};